import { Component } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApiService } from 'src/app/helpers/services/api.service';
import { HttpService } from 'src/app/helpers/services/http.service';
import { PublicService } from 'src/app/helpers/services/public.service';
import { ToastresService } from '../../../../../helpers/services/toaster.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { DeleteComponent } from '../delete/delete.component';
import { InviteComponent } from '../invite/invite.component';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { RolePermissionFormComponent } from '../role-permission-form/role-permission-form.component';
import { ScreenshotsListComponent } from '../screenshots-list/screenshots-list.component';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
})
export class UserProfileComponent {
  public userId: number;
  user: any;
  msg: string;

  constructor(
    public activeModal: NgbActiveModal,
    public publicService: PublicService,
    public httpService: HttpService,
    private api: ApiService,
    private ngbModal: NgbModal,
    private toastrsService: ToastresService,
  ) { }

  ngOnInit(): void {
    this.getUser();
  }

  getUser() {
    this.httpService
      .list(this.api.users.profile(this.userId), {}, 'userProfileLoader')
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.user = res.data;
          } else {
            this.msg = res.msg;
          }
        },
      });
  }

  resetPassword() {
    this.ngbModal.dismissAll();
    const modalRef = this.ngbModal.open(ResetPasswordComponent, {
      centered: true,
    });
    modalRef.componentInstance.user = this.user;
  }

  takeScreenshot() {
    this.httpService
      .action(this.api.users.takeScreenshot(this.user.id), {})
      .subscribe({
        next: (res: any) => {
          if (res.success) {
            this.toastrsService.ShowSuccess(res.msg);
          } else {
            this.toastrsService.ShowError(res.msg);
          }
        },
      });
  }

  viewScreenshots() {
    const modalRef = this.ngbModal.open(ScreenshotsListComponent, {
      size: 'xl',
      centered: true,
      scrollable: true,
    });
    modalRef.componentInstance.userId = this.user.id;
    modalRef.componentInstance.userName = this.user.full_name;
  }

  invite() {
    const modalRef = this.ngbModal.open(InviteComponent, {});
    modalRef.componentInstance.user = this.user;
  }

  customizePermissions() {
    const modalRef = this.ngbModal.open(RolePermissionFormComponent, {
      scrollable: true,
      size: 'xl',
    });
    modalRef.componentInstance.mode = 'user';
    modalRef.componentInstance.userId = this.user.id;
  }

  resetCustomizedPermissions() {
    const modalRef = this.ngbModal.open(ConfirmComponent);
    modalRef.componentInstance.title = 'ResetCustomizedPermissions';
    modalRef.componentInstance.message = 'ResetCustomizedPermissionsMessage';
    modalRef.componentInstance.confirmText = 'Reset';
    modalRef.componentInstance.cancelText = 'Cancel';
    modalRef.componentInstance.loadingKey = 'resetPermissionsLoader';

    modalRef.componentInstance.confirmAction.subscribe(() => {
      this.httpService.action(this.api.users.resetCustomizedPermissions(this.user.id), {}, 'resetPermissionsLoader').subscribe({
        next: (res: any) => {
          if (res?.success) {
            this.toastrsService.ShowSuccess(res.msg);
            modalRef.close();
          } else {
            modalRef.close();
          }
        }
      });
    });
  }

  delete() {
    const modalRef = this.ngbModal.open(DeleteComponent, {});
    modalRef.componentInstance.id = this.user.id;
    modalRef.componentInstance.type = 'user';
    modalRef.componentInstance.message = `Do you want to delete ${this.user.dual_name} ?`;
    modalRef.result.then(() => this.ngbModal.dismissAll());
  }
}
